.gridContainer {
    display: grid;
    align-items: flex-end;
    justify-content: flex-end;
}
